"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var gqlPriceFormatter_1 = require("../../../../common/hooks/prices/gqlPriceFormatter");
var DefaultText = function (_a) {
    var style = _a.style, paymentData = _a.paymentData;
    var _b, _c;
    var intl = react_intl_1.useIntl();
    return (<>
      <core_1.Typography component="h2" variant="body1" data-test="text:payment:subTitle" className={style.subTitle}>
        <react_intl_1.FormattedMessage id="trans__checkout__payment_page__subtitle"/>
      </core_1.Typography>
      {((_b = paymentData) === null || _b === void 0 ? void 0 : _b.amount) && (<core_1.Typography component="div" variant="body1" data-test="text:payment:description" className={style.paragraph}>
          <Translation_1.default id="trans__checkout__payment_page__description1" values={{
        amount: gqlPriceFormatter_1.gqlPriceFormatter().format((_c = paymentData) === null || _c === void 0 ? void 0 : _c.amount),
        mobile_phone: (<a href={"tel:" + intl.formatMessage({ id: 'trans__checkout__payment_page__phone_in_description' })}>
                  <Translation_1.default id="trans__checkout__payment_page__phone_in_description"/>
                </a>),
    }}/>
        </core_1.Typography>)}
    </>);
};
exports.default = DefaultText;
